import * as React from "react";
import Grid from "@mui/material/Grid";
import { CmpStatusIcon, CmpTypographyField } from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography, useMediaQuery } from "@mui/material";
export const  DetailTblCard = ({ data = [], onClick = () => {} }) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  return (
    <Grid container spacing={0.5} className=" easy-putaway-container-v1">
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
        >
          <div className="easy-putaway-card-v1">
            <Grid container spacing={1} columns={{ xs: 12, md: 12 }}>
              <Grid item xs={12} md={12} className="easy-putaway-card-sub-Item">
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-ItemName"
                >
                  {item.ItmName}
                </Typography>
              </Grid>
              <Grid item xs={1} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Qty
                </Typography>
              </Grid>
              <Grid item xs={1} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.DP_Qty}
                </Typography>
              </Grid>
              <Grid item xs={1.5} md={6}>
                <Typography
                  variant="subtitle2"
                  className="easy-putaway-card-sub-label"
                >
                  Unit
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.UnitName}
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Batch
                </Typography>
              </Grid>
              <Grid item xs={3.5} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.DP_Batch}
                </Typography>
              </Grid>
               
                
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
